import { type ReactNode } from 'react';

import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface StatsGridProps {
  children?: ReactNode;
  /** Number of columns at desktop width */
  columns?: 2 | 3 | 4 | 5 | 6;
  /** Show loading skeletons */
  isLoading?: boolean;
  /** Number of skeleton cards to show */
  skeletonCount?: number;
}

const gridColsMap = {
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-2 lg:grid-cols-3',
  4: 'sm:grid-cols-2 lg:grid-cols-4',
  5: 'sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5',
  6: 'sm:grid-cols-3 lg:grid-cols-6',
} as const;

export function StatsGrid({
  children,
  columns = 4,
  isLoading = false,
  skeletonCount,
}: StatsGridProps) {
  if (isLoading) {
    const count = skeletonCount ?? columns;
    return (
      <div className={cn('grid grid-cols-1 gap-3', gridColsMap[columns])}>
        {Array.from({ length: count }).map((_, i) => (
          <Card key={i}>
            <CardContent className="p-4">
              <div className="space-y-2">
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-6 w-14" />
                <Skeleton className="h-2 w-16" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return <div className={cn('grid grid-cols-1 gap-3', gridColsMap[columns])}>{children}</div>;
}
